import store from "../../store/index.js";

let tour = null;
let toursPromise = null;

const loadTours = () => {
  if (!toursPromise) {
    toursPromise = import(/* webpackChunkName: "tours" */ "./tours.js");
  }
  return toursPromise;
};

const nextStep = (step = null) => {
  if (!tour?.isActive()) return;
  if (
    tour.id.includes("initialTour") &&
    tour.getCurrentStep()?.id === "typing" &&
    step === "typing-complete"
  ) {
    tour.hide();
    // Move on once the make has opened
    const checkDrawerOpen = setInterval(() => {
      if (store.state.drawer.isOpen) {
        clearInterval(checkDrawerOpen);
        setTimeout(() => tour.next(), 600);
      }
    }, 200);
  } else if (step === null) {
    return tour.next();
  }
};

const wantsTour = (force_start) => {
  const tours = store.state.tours;
  if (force_start) return true;
  // The first tour starts from the welcome card or Help, never by itself
  if (!store.state.drawer.isOpen) return false;
  if (store.state.result.showResult) return tours.showResultTour;
  const tab = store.state.tabs.currentTab.name;
  if (tab === "Context") return tours.showContextTour;
  if (tab === "Questions") return tours.showQuestionsTour;
  if (tab === "Style") return tours.showStyleTour;
  return false;
};

const startTour = (tours, force_start) => {
  if (tour?.isActive()) {
    if (tour.id.includes("initialTour")) {
      store.dispatch("tours/completeInitialTour");
    } else if (tour.id.includes("resultTour")) {
      store.dispatch("tours/completeResultTour");
    } else if (tour.id.includes("contextTour")) {
      store.dispatch("tours/completeContextTour");
    } else if (tour.id.includes("questionsTour")) {
      store.dispatch("tours/completeQuestionsTour");
    } else if (tour.id.includes("styleTour")) {
      store.dispatch("tours/completeStyleTour");
    }
    tour.complete();
  }
  if (!store.state.drawer.isOpen) {
    if (force_start) {
      store.dispatch("tours/unsetInitialTour");
    }
    tour = tours.initialTour;
    tours.startInitialTour();
  } else if (store.state.result.showResult) {
    if (force_start) {
      store.dispatch("tours/unsetResultTour");
    }
    tour = tours.resultTour;
    setTimeout(() => {
      tours.startResultTour();
    }, 600);
  } else if (store.state.tabs.currentTab.name === "Context") {
    if (force_start) {
      store.dispatch("tours/unsetContextTour");
    }
    tour = tours.contextTour;
    setTimeout(() => {
      tours.startContextTour();
    }, 600);
  } else if (store.state.tabs.currentTab.name === "Questions") {
    if (force_start) {
      store.dispatch("tours/unsetQuestionsTour");
    }
    tour = tours.questionsTour;
    setTimeout(() => {
      tours.startQuestionsTour();
    }, 600);
  } else if (store.state.tabs.currentTab.name === "Style") {
    if (force_start) {
      store.dispatch("tours/unsetStyleTour");
    }
    tour = tours.styleTour;
    setTimeout(() => {
      tours.startStyleTour();
    }, 600);
  }
};

const newTour = (force_start = false) => {
  // Nothing to do (and nothing to download) unless a tour is running or wanted
  if (!tour?.isActive() && !wantsTour(force_start)) return;
  loadTours()
    .then((tours) => startTour(tours, force_start))
    .catch((error) => console.error("Could not load the tour", error));
};

export { nextStep, newTour };
